import { HomeScreenSectionTypeEnum, ICmsSection } from '../services/types';

export interface ParsedContent<T = unknown> {
  parsed: T | any;
  isValid: boolean;
}

// الأقسام الستاتيك اللي مش محتاجة عمل JSON parsing
const STATIC_CONTENT_SECTION_TYPES = new Set<HomeScreenSectionTypeEnum>([
  HomeScreenSectionTypeEnum.AllProducts,
]);

export const tryParseContent = <T = unknown>(
  content: any,
  sectionsType: HomeScreenSectionTypeEnum,
): ParsedContent<T> => {
  if (STATIC_CONTENT_SECTION_TYPES.has(sectionsType)) {
    return { parsed: content as unknown as T, isValid: true };
  }

  if (content === null || content === undefined) {
    return { parsed: null, isValid: false };
  }

  if (typeof content !== 'string') {
    const isValid = Array.isArray(content) ? content.length > 0 : Boolean(content);
    return { parsed: content as T, isValid };
  }

  try {
    const parsed = JSON.parse(content) as T;
    const isValid = Array.isArray(parsed) ? parsed.length > 0 : Boolean(parsed);
    return { parsed, isValid };
  } catch {
    return { parsed: null, isValid: false };
  }
};

export const isValidSection = (section: ICmsSection): boolean => {
  if (STATIC_CONTENT_SECTION_TYPES.has(section.sectionsType)) return true;

  const { content } = section;
  if (content === null || content === undefined) return false;

  if (typeof content === 'string') {
    try {
      const parsed: unknown = JSON.parse(content);
      if (parsed === null) return false;
      if (typeof parsed === 'string') return parsed.trim().length > 0;
      if (typeof parsed === 'number' || typeof parsed === 'boolean') return true;
      if (Array.isArray(parsed)) return parsed.length > 0;
      if (typeof parsed === 'object') return Object.keys(parsed as object).length > 0;
      return false;
    } catch {
      return false;
    }
  }

  if (typeof content === 'number' || typeof content === 'boolean') return true;
  if (Array.isArray(content)) return (content as unknown[]).length > 0;
  if (typeof content === 'object') return Object.keys(content as object).length > 0;

  return false;
};
